import { observer } from 'mobx-react';
import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';

import store from 'stores/RootStore';

const Container = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;

interface AnimationContainerProps {
  $scale: number;
}

const AnimationContainer = styled.div<AnimationContainerProps>`
  overflow: visible;
  transform: ${(p) => `scale(${p.$scale})`};
  transform-origin: center center;
`;

function AnimationStageFrame() {
  const store_preview = store.preview;
  const previewURL = store_preview?.previewURL;

  const animationContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (store_preview && previewURL && animationContainerRef.current) {
      store_preview.player.loadAnimation(
        animationContainerRef.current,
        previewURL
      );
      return () => {
        store_preview.player.destroy();
      };
    }
  }, [store_preview, previewURL]);

  return (
    <Container>
      <AnimationContainer
        ref={animationContainerRef}
        $scale={store_preview?.player.scale ?? 1}
      />
    </Container>
  );
}

export default observer(AnimationStageFrame);
